import {createStrokeSVG} from './TEMPLATE'

// tabler: flame
export const Flame_Stroke2_Corner1_Rounded = createStrokeSVG({
  paths: [
    'M12 10.941c2.333 -3.308 .167 -7.823 -1 -8.941c0 3.395 -2.235 5.299 -3.667 6.706c-1.43 1.408 -2.333 3.294 -2.333 5.588c0 3.704 3.134 6.706 7 6.706c3.866 0 7 -3.002 7 -6.706c0 -1.712 -1.232 -4.403 -2.333 -5.588c-2.084 3.353 -3.257 3.353 -4.667 2.235',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
